import { DropResult } from '@hello-pangea/dnd'
import { CatalogueItem, CategoryNode } from './catalogueTypes'

export const MAIN_DROPPABLE_ID = 'droppable'
export const MAIN_DROPPABLE_TYPE = 'MAIN'
export const NESTED_DROPPABLE_TYPE = 'NESTED'
const NESTED_DROPPABLE_PREFIX = 'droppable-'

export const nestedDroppableId = (category: CategoryNode): string => `${NESTED_DROPPABLE_PREFIX}${category.id}`

const categoryIdOfDroppable = (droppableId: string): number => Number(droppableId.slice(NESTED_DROPPABLE_PREFIX.length))

export const renumberPositions = <T extends { position: number }>(list: readonly T[]): T[] =>
  list.map((item, index) => ({ ...item, position: index + 1 }))

export const moveItemAndRenumberPositions = <T extends { position: number }>(list: readonly T[], from: number, to: number): T[] => {
  const result = [...list]
  const [moved] = result.splice(from, 1)
  result.splice(to, 0, moved)
  return renumberPositions(result)
}

export const reorderTable = (rows: CatalogueItem[], result: DropResult): CatalogueItem[] | null => {
  if (!result.destination) return null
  const { source, destination } = result
  if (source.droppableId !== destination.droppableId) return null

  if (result.type === MAIN_DROPPABLE_TYPE) {
    return moveItemAndRenumberPositions(rows, source.index, destination.index)
  }

  const categoryId = categoryIdOfDroppable(destination.droppableId)
  return rows.map((row) => {
    if (row.class_name !== 'ProductCategory' || row.id !== categoryId) return row
    return { ...row, children: moveItemAndRenumberPositions(row.children, source.index, destination.index) }
  })
}

interface PositionEntry {
  id: number
  class_name: string
  position: number
  children?: PositionEntry[]
}

const positionEntry = (item: CatalogueItem): PositionEntry => ({
  id: item.id,
  class_name: item.class_name,
  position: item.position,
  ...(item.class_name === 'ProductCategory' ? { children: item.children.map(positionEntry) } : {})
})

export const tablePositionsPayload = (rows: CatalogueItem[]): PositionEntry[] => rows.map(positionEntry)

export const rootPositionsPayload = (roots: CategoryNode[]): PositionEntry[] =>
  roots.map(({ id, class_name, position }) => ({ id, class_name, position }))
